<template>
  <div>
    <div class="page-mentor">
      <div class="g-wrap">
        <el-breadcrumb class="g-breadcrumb" separator="/">
          <el-breadcrumb-item :to="`${$subsitePrefix}/innovation`">创新创业</el-breadcrumb-item>
          <el-breadcrumb-item> 投资人 </el-breadcrumb-item>
        </el-breadcrumb>
        <div class="g-content mentor-content">
          <form-generator v-if="isShow" ref="mainForm" v-model="formData" :config="config">
            <template slot="bottom">
              <el-button :loading="isUploading" type="primary" @click="submitForm" style="margin-left:120px">提交</el-button>
            </template>
          </form-generator>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {
  createEntity,
  fetchInitFormSet
} from '@/api/content-data'
export default {
  name: 'InvestorCreate',
  data() {
    return {
      isUploading: false,
      isShow: false,
      // proportion: 100,
      sid: '',
      id: '',
      tableId: 'Investor',
      formData: {},
      config: {
        fieldsConfig: [
        ],
        buttons: {
          onSubmitText: '提交',
          onResetText: '重置'
        }
      }
    }
  },
  created() {
    fetchInitFormSet(this.tableId, this.id, this.sid)
      .then(response => {
        if (response) {
          // this.$set(this, 'formData', response.formData)
          // this.$set(this.config, 'fieldsConfig', response.fieldsConfig)
          // this.formData = response.Result.formData
          this.formData = response.Result.formData
          this.config.fieldsConfig = response.Result.fieldsConfig
          // this.config.fieldsConfig = response.Result.fieldsConfig
          this.isShow = true
        }
      })
      .catch(err => {
        console.log(err);
      })
  },
  methods: {
    editUpload(val) {
      console.log('上传状态', val)
      this.isUploading = val
    },
    async submitForm(v) {
      if (this.isUploading) {
        return
      } else {
        this.isUploading = true
      }
      this.loading = true
      var isSuccess = false
      var msg = '服务器错误！'
      this.formData.TableId = this.tableId
      var postData = Object.assign({}, this.formData)
      debugger
      if (v === 1) {
        postData.WorkFlowState = 1
      } else {
        postData.WorkFlowState = 2
      }
      this.$refs.mainForm.$refs.form.validate(async valid => {
        try {
          if (valid) {
            const response = await createEntity(postData)
            if (response.Status === 0) {
              isSuccess = response.Result
              msg = response.Message
            }
            this.loading = false
            if (isSuccess) {
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000
              })
              this.$router.go(-1)
            } else {
              this.$notify({
                title: '保存失败',
                message: msg,
                type: 'error',
                duration: 2000
              })
            }
          } else {
            this.$notify({
              title: '保存失败',
              message: '表单填写有误',
              type: 'warning',
              duration: 2000
            })
            return false
          }
        } finally {
          this.isUploading = false
        }
      })
    },
  }
}
</script>


<style lang="scss" scoped>
.page-mentor {
  background: #f6f6f9;
  padding-bottom: 40px;
  .mentor-content {
    padding: 20px 20px 40px 20px;
    .content {
      font-size: 14px;
      line-height: 28px;
      color: #666;
      padding-bottom: 20px;
    }
    ::v-deep .comp-column-header {
      padding-top: 24px;
    }
    .content-wrap {
      margin: 0 168px;
    }
  }
}
/deep/.sectionLine {
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(229, 229, 229, 1);
  margin-bottom: 10px;
}
/deep/.divSection {
  height: 18px;
  width: 4px;
  float: left;
  border-radius: 2px;
  background-color: #1890ff;
}
/deep/.sectionTitle {
  line-height: 18px;
  margin-left: 8px;
  font-size: 16px;
  font-weight: bold;
}

/deep/.inline {
  display: inline-block;
}
</style>